// extracted by mini-css-extract-plugin
export var customFooter = "footer-cta-module--customFooter--37473";
export var description = "footer-cta-module--description--483c6";
export var root = "footer-cta-module--root--62813";
export var title = "footer-cta-module--title--28b1b";